export default function CouponPast(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="922" height="146" viewBox="0 0 922 146" fill="none" {...props}>
            <mask id="path-1-inside-1_3454_15954" fill="white">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 10C0 4.47715 4.47715 0 10 0H912C917.523 0 922 4.47715 922 10V63C910.954 63 902 71.7854 902 82.6226C902 93.4599 910.954 102.245 922 102.245V136C922 141.523 917.523 146 912 146H9.99997C4.47713 146 0 141.523 0 136V102.245C11.0457 102.245 20 93.4599 20 82.6226C20 71.7854 11.0457 63 0 63V10Z"
                />
            </mask>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 10C0 4.47715 4.47715 0 10 0H912C917.523 0 922 4.47715 922 10V63C910.954 63 902 71.7854 902 82.6226C902 93.4599 910.954 102.245 922 102.245V136C922 141.523 917.523 146 912 146H9.99997C4.47713 146 0 141.523 0 136V102.245C11.0457 102.245 20 93.4599 20 82.6226C20 71.7854 11.0457 63 0 63V10Z"
                fill="url(#paint0_linear_3454_15954)"
            />
            <path
                d="M922 63V65H924V63H922ZM922 102.245H924V100.245H922V102.245ZM0 102.245V100.245H-2V102.245H0ZM0 63H-2V65H0V63ZM10 -2C3.37258 -2 -2 3.37258 -2 10H2C2 5.58172 5.58172 2 10 2V-2ZM912 -2H10V2H912V-2ZM924 10C924 3.37259 918.627 -2 912 -2V2C916.418 2 920 5.58172 920 10H924ZM924 63V10H920V63H924ZM904 82.6226C904 72.9257 912.023 65 922 65V61C909.886 61 900 70.645 900 82.6226H904ZM922 100.245C912.023 100.245 904 92.3196 904 82.6226H900C900 94.6002 909.886 104.245 922 104.245V100.245ZM924 136V102.245H920V136H924ZM912 148C918.627 148 924 142.627 924 136H920C920 140.418 916.418 144 912 144V148ZM9.99997 148H912V144H9.99997V148ZM-2 136C-2 142.627 3.37255 148 9.99997 148V144C5.5817 144 2 140.418 2 136H-2ZM-2 102.245V136H2V102.245H-2ZM18 82.6226C18 92.3196 9.97721 100.245 0 100.245V104.245C12.1142 104.245 22 94.6002 22 82.6226H18ZM0 65C9.97721 65 18 72.9257 18 82.6226H22C22 70.645 12.1142 61 0 61V65ZM-2 10V63H2V10H-2Z"
                fill="url(#paint1_linear_3454_15954)"
                mask="url(#path-1-inside-1_3454_15954)"
            />
            <defs>
                <linearGradient id="paint0_linear_3454_15954" x1="572.385" y1="-162.575" x2="627.67" y2="342.352" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0593887" stopColor="#3F68E0" />
                    <stop offset="0.315206" stopColor="#071B31" />
                    <stop offset="0.329737" stopColor="#071A2F" />
                    <stop offset="0.538019" stopColor="#05121F" />
                    <stop offset="0.69452" stopColor="#001934" />
                    <stop offset="1" stopColor="#3F68E0" />
                </linearGradient>
                <linearGradient id="paint1_linear_3454_15954" x1="-19.9146" y1="-65.7705" x2="289.777" y2="577.633" gradientUnits="userSpaceOnUse">
                    <stop offset="0.108269" stopColor="#2F2F2F" />
                    <stop offset="0.587124" stopColor="#C9C9C9" />
                    <stop offset="0.899897" stopColor="#363636" />
                </linearGradient>
            </defs>
        </svg>
    );
}
